
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import MaterialPurchase from "../components/materialpurchase";
import Footer from "../components/footer";

function MaterialPurchasePage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <MaterialPurchase /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default MaterialPurchasePage;
